import request from '@/utils/request'

// 获取统计数据（组委会）
export const getDashboardStats = () => {
  return mockGetDashboardStats()
}

// 获取学校管理员数据看板
export const getSchoolAdminDashboard = () => {
  return request.fGet('/teacher/admin/dashboard/school')
}

// 获取区管理员数据看板
export const getDistrictAdminDashboard = () => {
  return request.fGet('/district/dashboard')
}

// 获取市管理员数据看板
export const getCityAdminDashboard = () => {
  return request.fGet('/city/dashboard')
}

// 获取用户列表（组委会）
export const getUsers = (params) => {
  return request.fPost('/org/user/list', params)
}

// 获取用户列表（市级管理员）
export const getCityUsers = (params) => {
  return request.fPost('/city/user/list', params)
}

// 获取用户列表（区级管理员）
export const getDistrictUsers = (params) => {
  return request.fPost('/district/user/list', params)
}

/**
 * 新增用户（组委会）
 * @param {Object} data - 用户数据
 * @param {string} data.cityId - 城市ID
 * @param {string} data.districtId - 区县ID
 * @param {string} data.grade - 年级
 * @param {string} data.idCard - 身份证号
 * @param {string} data.idCardType - 身份证类型
 * @param {string} data.loginName - 登录账号
 * @param {string} data.realName - 姓名
 * @param {string} data.roleCode - 角色编码
 * @param {string} data.schoolId - 学校ID
 * @param {string} data.sex - 性别（MALE-男, FEMALE-女）
 * @returns {Promise}
 */
export const addUser = (data) => {
  return request.fPost('/org/user/add', data)
}

/**
 * 修改用户（组委会）
 * @param {Object} data - 用户数据
 * @param {string} data.id - 用户ID
 * @param {string} data.authStatus - 认证状态
 * @param {string} data.cityId - 城市ID
 * @param {string} data.districtId - 区县ID
 * @param {string} data.grade - 年级
 * @param {string} data.idCard - 身份证号
 * @param {string} data.idCardType - 身份证类型
 * @param {string} data.realName - 姓名
 * @param {string} data.roleCode - 角色编码
 * @param {string} data.schoolId - 学校ID
 * @param {string} data.sex - 性别（MALE-男, FEMALE-女）
 * @param {string} data.state - 状态（1-启用, 0-禁用）
 * @returns {Promise}
 */
export const editUser = (data) => {
  return request.fPost('/org/user/edit', data)
}

/**
 * 重置用户密码（组委会）
 * @param {Object} data - 参数
 * @param {string} data.userId - 用户ID
 * @param {string} data.pwdNew - 新密码
 * @returns {Promise}
 */
export const resetUserPwd = (data) => {
  return request.fPost('/org/user/resetPwd', data)
}

/**
 * 切换用户状态（启用/禁用）
 * @param {Object} data - 参数
 * @param {string} data.id - 用户ID
 * @param {string} data.state - 状态（1-启用, 0-禁用）
 * @returns {Promise}
 */
export const toggleUserState = (data) => {
  return request.fPost('/org/user/toggleState', data)
}

/**
 * 获取学校列表（通用接口）
 * @param {Object} params - 查询参数
 * @param {string} [params.districtId] - 区县ID
 * @param {string} [params.cityId] - 城市ID
 * @returns {Promise}
 */
export function getSchoolApplyList(params) {
  return request.fPost('/area/schoolList', params);
}

/**
 * 获取区学校申请列表（已废弃，使用getSchoolApplyList）
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getDistrictSchoolApplyList(params) {
  return request.fPost('/area/schoolList', params);
}

/**
 * 获取市学校申请列表（已废弃，使用getSchoolApplyList）
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getCitySchoolApplyList(params) {
  return request.fPost('/area/schoolList', params);
}

/**
 * 审核学校申请
 * @param {Object} data - 审核参数
 * @param {string} data.applyId - 申请记录ID
 * @param {string} data.result - 审核结果 (PENDING-待审核, APPROVED-已通过, REJECTED-已拒绝)
 * @param {string} [data.rejectReason] - 拒绝原因（可选）
 * @returns {Promise}
 */
export function reviewSchoolApply(data) {
  return request.fPost('/district/school/review', data);
}

/**
 * 晋级到市级比赛
 * @param {Object} data - 晋级参数
 * @param {string} data.materialId - 作品ID
 * @param {string} data.recommendFlag - 推荐标志 (Y/N)
 * @returns {Promise}
 */
export function districtPromoteToCity(data) {
  return request.fPost('/district/material/promoteToCity', data);
}

export function cityPromoteToSemifinal(data) {
  return request.fPost('/city/material/promoteToSemifinal', data);
}

/**
 * 区管理员批量公布推荐结果
 * @param {Object} data - 发布推荐结果参数
 * @returns {Promise}
 */
export function districtBatchPublicize(data) {
  return request.fPost('/district/material/batchPublicize', data);
}

/**
 * 市管理员公布初赛成绩
 * @param {Object} data - 参数
 * @returns {Promise}
 */
export function cityBatchPublicize(data) {
  return request.fPost('/city/material/batchPublicize', data);
}

/**
 * 市管理员打回复赛视频
 * @param {Object} data - 参数
 * @param {string} data.materialId - 作品ID
 * @returns {Promise}
 */
export function cityRevokeSemifinalVideo(data) {
  return request.fPost('/city/material/revokeSemifinalVideo', data);
}

/**
 * 区管理员评分
 * @param {Object} data - 评审参数
 * @param {string} data.materialId - 作品ID
 * @param {number} data.districtCompletenessStructure - 完整结构要素(20)
 * @param {number} data.districtCompletenessFormat - 格式与表述规范(10)
 * @param {number} data.districtSciencePrinciple - 原理准确性(12)
 * @param {number} data.districtScienceLogic - 实验逻辑与变量控制(13)
 * @param {number} data.districtInnovationDesign - 创新设计(12)
 * @param {number} data.districtInnovationValue - 探究与应用价值(8)
 * @param {number} data.districtPracticalEquipment - 器材适配性(8)
 * @param {number} data.districtPracticalOperation - 操作与时长适配(7)
 * @param {number} data.districtSafetyDesign - 安全设计(6)
 * @param {number} data.districtSafetyEco - 环保与废弃物处理(4)
 * @param {string} data.districtReviewComment - 区级评审意见
 * @returns {Promise}
 */
export function districtReviewPreliminary(data) {
  return request.fPost('/district/material/reviewScoring', data);
}

/**
 * 获取竞赛详情（组委会专用）
 * @returns {Promise}
 */
export function getContestDetail() {
  return request.fGet('/org/contest/detail');
}

/**
 * 获取竞赛详情（通用接口 - 其他角色和场景）
 * @returns {Promise}
 */
export function getCommonContestDetail() {
  return request.fGet('/contest/detail');
}

/**
 * 编辑竞赛配置
 * @param {Object} data - 竞赛配置参数
 * @param {string} data.contestName - 活动名称
 * @param {string} data.contestYear - 活动年份
 * @param {string} data.contestDesc - 活动描述
 * @param {string} data.signupStartTime - 报名开始时间
 * @param {string} data.signupEndTime - 报名结束时间
 * @param {string} data.preliminaryStartTime - 初赛材料提交开始时间
 * @param {string} data.preliminaryEndTime - 初赛材料提交结束时间
 * @param {string} data.semifinalStartTime - 复赛材料提交开始时间
 * @param {string} data.semifinalEndTime - 复赛材料提交结束时间
 * @param {string} data.reviewStartTime - 评审开始时间
 * @param {string} data.reviewEndTime - 评审结束时间
 * @param {number} data.ageMin - 最小年龄
 * @param {number} data.ageMax - 最大年龄
 * @param {number} data.schoolRecommendQuota - 学校推荐名额
 * @param {number} data.districtPromoteQuota - 区级晋级名额
 * @param {number} data.cityPromoteQuota - 市级晋级名额
 * @param {number} data.totalQuota - 总晋级名额
 * @returns {Promise}
 */
export function editContestConfig(data) {
  return request.fPost('/org/contest/edit', data);
}

/**
 * 获取作品列表（组委会专用）
 * @param {Object} params - 查询参数
 * @param {string} [params.cityId] - 城市ID
 * @param {string} [params.contestId] - 竞赛ID
 * @param {string} [params.districtId] - 区县ID
 * @param {string} [params.schoolId] - 学校ID
 * @param {string} [params.direction] - 参赛方向
 * @param {string} [params.reviewStatus] - 评审状态
 * @param {string} [params.preliminaryStatus] - 初赛状态
 * @param {string} [params.semifinalStatus] - 复赛状态
 * @param {string} [params.isRecommended] - 是否推荐（Y/N）
 * @param {string} [params.userSearch] - 用户名称：姓名/手机号
 * @param {number} [params.pageNum] - 页码
 * @param {number} [params.pageSize] - 每页数量
 * @param {boolean} [params.needCount] - 是否需要总数
 * @param {boolean} [params.needPage] - 是否需要分页
 * @returns {Promise}
 */
export function getOrganizerMaterialList(params) {
  return request.fPost('/org/material/list', params);
}

/**
 * 获取作品详情（组委会专用）
 * @param {Object} params - 查询参数
 * @param {string} params.materialId - 材料ID
 * @returns {Promise}
 */
export function getOrganizerMaterialDetail(params) {
  return request.fGet('/org/material/detail', params);
}

/**
 * 获取市级作品列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export function getCityMaterialList(params) {
  return request.fPost('/city/material/list', params);
}

/**
 * 获取市级作品详情
 * @param {Object} params - 查询参数
 * @param {string} params.materialId - 材料ID
 * @returns {Promise}
 */
export function getCityMaterialDetail(params) {
  return request.fGet('/city/material/detail', params);
}

/**
 * 获取资讯列表
 * @param {Object} params - 查询参数
 * @param {number} [params.pageNum] - 页码
 * @param {number} [params.pageSize] - 每页数量
 * @param {string} [params.title] - 标题搜索
 * @param {string} [params.type] - 资讯类型
 * @param {string} [params.state] - 发布状态
 * @returns {Promise}
 */
export function getNewsList(params) {
  return request.fPost('/org/news/list', params);
}

/**
 * 获取资讯详情
 * @param {Object} params - 查询参数
 * @param {string} params.id - 资讯ID
 * @returns {Promise}
 */
export function getNewsDetail(params) {
  return request.fGet('/org/news/detail', params);
}

/**
 * 新增资讯
 * @param {Object} data - 资讯数据
 * @param {string} data.title - 标题
 * @param {string} [data.headUrl] - 标题图URL
 * @param {string} data.content - 资讯内容（富文本HTML）
 * @param {string} [data.type] - 资讯类型: 01-活动动态, 02-活动新闻等
 * @param {string} [data.source] - 来源
 * @param {string} [data.remark] - 备注
 * @returns {Promise}
 */
export function addNews(data) {
  return request.fPost('/org/news/add', data);
}

/**
 * 编辑资讯
 * @param {Object} data - 资讯数据
 * @param {string} data.id - 主键ID
 * @param {string} data.title - 标题
 * @param {string} [data.headUrl] - 标题图URL
 * @param {string} data.content - 资讯内容（富文本HTML）
 * @param {string} [data.type] - 资讯类型: 01-活动动态, 02-活动新闻等
 * @param {string} [data.source] - 来源
 * @param {string} [data.remark] - 备注
 * @returns {Promise}
 */
export function editNews(data) {
  return request.fPost('/org/news/edit', data);
}

/**
 * 更改资讯发布状态
 * @param {Object} data - 参数
 * @param {string} data.id - 资讯ID
 * @param {string} data.state - 发布状态: 0-待发布, 1-已发布
 * @returns {Promise}
 */
export function changeNewsStatus(data) {
  return request.fPost('/org/news/changeStatus', data);
}

/**
 * 删除资讯
 * @param {Object} data - 参数
 * @param {string} data.id - 资讯ID
 * @returns {Promise}
 */
export function deleteNews(data) {
  return request.fPost('/org/news/delete', data);
}

/**
 * 获取百家云播放凭证
 * @param {Object} params - 参数
 * @param {string} params.tempFileId - 视频临时文件ID（从作品的videoUrl获取）
 * @returns {Promise}
 */
export function getBjyPlayerToken(params) {
  return request.fGet('/material/bjyPlayerToken', params);
}
